<div class="w-full">
    <!-- Form -->
    <form *ngIf="accountForm" [formGroup]="accountForm">
        <div class="row">
            <div class="col-sm-6">
                <!-- RFC -->
                <div class="mt-5">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>RFC </mat-label>
                        <input matInput [formControlName]="'rfc'" maxlength="13" placeholder="Ejemplo: ABC123456XYZ" (blur)="onRfcBlur()" (input)="convertToUpper($event)">
                    </mat-form-field>
                    <ng-container
                        *ngIf="accountForm.controls['rfc'].invalid && (accountForm.controls['rfc'].dirty || accountForm.controls['rfc'].touched)">
                        <div *ngIf="accountForm.controls['rfc'].errors?.['required']"
                            class="text-md text-hint text-danger">
                            Este campo es requerido
                        </div>
                        <div *ngIf="accountForm.controls['rfc'].errors?.['pattern']"
                            class="text-md text-hint text-danger">
                            Formato de RFC inválido
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="col-sm-6">
                <div *ngIf="rfcValidationStarted && !rfcAvailable" class="d-flex align-items-center alert-spacer">
                    <mat-icon svgIcon="mat_outline:error_outline"></mat-icon>
                    <div class="ml-2 text-ancho text-danger">El RFC proporcionado ya se encuentra registrado.</div>
                </div>
                
                <div *ngIf="rfcValidationStarted && rfcAvailable" class="d-flex align-items-center alert-spacer">
                    <mat-icon class="text-success" svgIcon="mat_outline:check"></mat-icon>
                    <div class="ml-2 text-ancho">RFC disponible para el registro.</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <!-- Razón social -->
                <div class="sm:col-span-4 mt-5">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Nombre completo o Razón social (Si es una empresa)</mat-label>
                        <input matInput [formControlName]="'razonSocial'" maxlength="350"
                            placeholder="Ejemplo: Juan Pérez o Mi Empresa S.A. de C.V." (blur)="onRazonSocialBlur()">
                        <!-- <mat-hint>Nombre oficial registrado o el nombre completo si eres persona física.</mat-hint> -->
                    </mat-form-field>
                    <ng-container
                        *ngIf="accountForm.controls['razonSocial'].invalid && (accountForm.controls['razonSocial'].dirty || accountForm.controls['razonSocial'].touched)">
                        <div *ngIf="accountForm.controls['razonSocial'].errors?.['required']"
                            class="mt-1 text-md text-hint text-danger">
                            Este campo es requerido
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="col-sm-6">
                <div *ngIf="razonSocialValidationStarted && !razonSocialAvailable" class="d-flex align-items-center alert-spacer">
                    <mat-icon svgIcon="mat_outline:error_outline"></mat-icon>
                    <div class="ml-2 text-ancho text-danger">La razón social proporcionado ya se encuentra registrado.</div>
                </div>
                
                <div *ngIf="razonSocialValidationStarted && razonSocialAvailable" class="d-flex align-items-center alert-spacer">
                    <mat-icon class="text-success" svgIcon="mat_outline:check"></mat-icon>
                    <div class="ml-2 text-ancho">Razón social disponible para el registro.</div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <!-- Nombre comercial -->
                <div class="sm:col-span-4 mt-5">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Nombre comercial</mat-label>
                        <input matInput [formControlName]="'nombreComercial'" maxlength="350"
                            placeholder="Ejemplo: Mi Marca">
                        <mat-hint>Si no tienes nombre comercial proporciona tu nombre.</mat-hint>
                    </mat-form-field>
                    <ng-container
                        *ngIf="accountForm.controls['nombreComercial'].invalid && (accountForm.controls['nombreComercial'].dirty || accountForm.controls['nombreComercial'].touched)">
                        <div *ngIf="accountForm.controls['nombreComercial'].errors?.['required']"
                            class="mt-1 text-md text-hint text-danger">
                            Este campo es requerido
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="col-sm-3">
                <!-- Tipo de persona -->
                <div class="sm:col-span-2 mt-5">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>¿Qué tipo de contribuyente eres?</mat-label>
                        <mat-select [formControlName]="'idTipoPersona'" (ngModelChange)="setDataGiro()">
                            <mat-option *ngFor="let item of catTipoPersona" [value]="item.id">{{ item.attributes.nombre
                                }}</mat-option>
                        </mat-select>
                        <!-- <mat-hint>Elige si eres una empresa (persona moral) o una persona física.</mat-hint> -->
                    </mat-form-field>
                    <ng-container
                        *ngIf="accountForm.controls['idTipoPersona'].invalid && (accountForm.controls['idTipoPersona'].dirty || accountForm.controls['idTipoPersona'].touched)">
                        <div *ngIf="accountForm.controls['idTipoPersona'].errors?.['required']"
                            class="mt-1 text-md text-hint text-danger">
                            Este campo es requerido
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="col-sm-3">
                <!-- Giro u ocupación -->
                <div class="sm:col-span-2 mt-5">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Actividad económica o Giro</mat-label>
                        <mat-select [formControlName]="'idGiro'">
                            <mat-option *ngFor="let item of catGiro" [value]="item.id">{{ item.attributes.nombre
                                }}</mat-option>
                        </mat-select>
                        <!-- <mat-hint>Indica la actividad principal de tu negocio.</mat-hint> -->
                    </mat-form-field>
                    <ng-container
                        *ngIf="accountForm.controls['idGiro'].invalid && (accountForm.controls['idGiro'].dirty || accountForm.controls['idGiro'].touched)">
                        <div *ngIf="accountForm.controls['idGiro'].errors?.['required']"
                            class="mt-1 text-md text-hint text-danger">
                            Este campo es requerido
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-9">
                <!-- Régimen fiscal -->
                <div class="sm:col-span-4 mt-5">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Régimen fiscal </mat-label>
                        <mat-select [formControlName]="'idRegimenFiscal'">
                            <mat-option *ngFor="let item of catReg" [value]="item.id">{{ item.attributes.clave }} - {{
                                item.attributes.descripcion }}</mat-option>
                        </mat-select>
                        <!-- <mat-hint>Selecciona el régimen fiscal bajo el cual tributas.</mat-hint> -->
                    </mat-form-field>
                    <ng-container
                        *ngIf="accountForm.controls['idRegimenFiscal'].invalid && (accountForm.controls['idRegimenFiscal'].dirty || accountForm.controls['idRegimenFiscal'].touched)">
                        <div *ngIf="accountForm.controls['idRegimenFiscal'].errors?.['required']"
                            class="mt-1 text-md text-hint text-danger">
                            Este campo es requerido
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="col-sm-3">
                <!-- Tamaño de la empresa -->
                <div class="sm:col-span-2 mt-5">
                    <mat-form-field class="fuse-mat-no-subscript w-full">
                        <mat-label>Tamaño de tu empresa</mat-label>
                        <mat-select [formControlName]="'idTamanioEmpresa'">
                            <mat-option *ngFor="let item of catTamanio" [value]="item.id">{{ item.attributes.descripcion
                                }}</mat-option>
                        </mat-select>
                        <!-- <mat-hint>Define el tamaño de tu empresa según empleados.</mat-hint> -->
                    </mat-form-field>
                    <ng-container
                        *ngIf="accountForm.controls['idTamanioEmpresa'].invalid && (accountForm.controls['idTamanioEmpresa'].dirty || accountForm.controls['idTamanioEmpresa'].touched)">
                        <div *ngIf="accountForm.controls['idTamanioEmpresa'].errors?.['required']"
                            class="mt-1 text-md text-hint text-danger">
                            Este campo es requerido
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </form>
</div>